<template>
  <el-dialog
    top="50px"
    width="1200px"
    :title="action.name || ''"
    :visible="visible"
    :show-close="!callingAPI"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('close')"
  >
    <ApproveForm
      :item="item"
      :disabled="callingAPI"
      :form="form"
      :update-fields="updateFields"
      :update-form="updateForm"
      :show-fields="showFields"
      :log-fields="logFields"
      :log-form="logForm"
      :config-modules="configModules"
    />
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        :disabled="callingAPI"
        size="medium"
        @click="$emit('close')"
      >
        Đóng
      </el-button>
      <el-button
        type="primary"
        :loading="callingAPI"
        size="medium"
        @click="handleConfirm"
        >Xác nhận</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { notification, arrayToObject } from "@/utils/common";
import ApproveForm from "@/components/items/ApproveForm.vue";
import approvedServices from "@/services/approved";
import constants from "@/config/constants";

export default {
  name: "RequestFormPopup",
  components: {
    ApproveForm,
  },
  props: {
    item: Object,
    objectType: Object,
    contract: Object,
    action: Object,
    config: Object,
    visible: Boolean,
  },
  data() {
    return {
      form: {
        notes: '',
      },
      updateForm: {},
      logForm: {},
      callingAPI: false,
      fieldType: constants.FIELD_TYPE,
    };
  },
  computed: {
    ...mapGetters("contract", ["allContractSteps"]),
    ...mapGetters("category", ["allCategories"]),
    fields() {
      return this.config.extra?.fields || []
    },
    configContracts() {
      return this.config.extra?.contracts || []
    },
    configModules() {
      return this.config.extra?.modules || []
    },
    currentContract() {
      return this.configContracts.find((c) => c.contract_id === this.contract.id)
    },
    currentContractStep() {
      return this.allContractSteps.find((s) => s.id === this.action.step_id)
    },
    configStep() {
      if (this.currentContract) {
        return this.currentContract.steps.find((s) => s.step_id === this.action.step_id) || {
          step_id: this.action.step_id,
          show_fields: [],
          update_fields: [],
          log_fields: []
        }
      }
      return {
        step_id: this.action.step_id,
        show_fields: [],
        update_fields: [],
        log_fields: []
      }
    },
    showFields() {
      return this.fields.filter((f) => this.configStep.show_fields.includes(f.key))
    },
    updateFields() {
      return this.fields.filter((f) => this.configStep.update_fields.includes(f.key))
    },
    logFields() {
      return this.configStep.log_fields
    },
    paramData() {
      const data = {
        contract_id: this.contract.id,
        action_id: this.action.id
      };
      return data;
    },
    payloadData() {
      const data = {
        notes: this.form.notes,
        extra_data: {
          ...this.logForm,
          override: {
            ...this.updateForm
          }
        }
      };
      if (this.action.started) {
        return data
      }
      return {
        ...data,
        document_id: this.item.id,
        document_type: this.objectType.role_action,
      };
    },
  },
  beforeMount() {
    this.loadFormData();
  },
  methods: {
    loadFormData() {
      this.form = { notes: '' };
      this.updateForm = arrayToObject(this.updateFields);
      this.logForm = arrayToObject(this.logFields)
    },
    handleConfirm() {
      this.callingAPI = true;
      let request = null
      if (this.action.started) {
        request = approvedServices.execute(this.payloadData, this.action.execution.url)
      } else {
        request = approvedServices.start(this.payloadData, this.paramData)
      }
      request
        .then(() => {
          this.callingAPI = false;
          this.$emit("reload");
          notification(this, "success", "", 'Gửi yêu cầu');
          this.$emit("close");
        })
        .catch(() => {
          this.callingAPI = false;
          notification(this, "error", "", 'Gửi yêu cầu');
        });
    }
  },
};
</script>

<style lang="scss" scoped></style>
